import api from "PFCore/api";
import { ActivityCounters } from "PFTypes/workflow_inbox";

export type FetchActivityCountersPayload = { templateKey: "role" | "engagement" };

export const fetchActivityCounters = ({
  templateKey
}: FetchActivityCountersPayload): Promise<ActivityCounters> =>
  api({
    url: "workflow_inbox/activities_counters",
    params: {
      filters: { fields: { templateKey } }
    }
  });
